import React from "react";
import { Box, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";

// The "assessment settings" strip in the survey builder header: Impact
// assessment | (Survey language). One column on
// narrow screens. `compact` (the classic builder, whose fields carry no helper
// lines) is the same strip with a tighter vertical rhythm: a slim band rather
// than a block.
export default function LinkSettingsLayout({
    id,
    project,
    language = null,
    delivery = null, // optional third column: how respondents take it (classic builder)
    title = true,
    variant = "strip",
    compact = false,
    sx,
}) {
    const columns = delivery
        ? { xs: "1fr", sm: "minmax(220px, 300px) minmax(150px, 180px) minmax(200px, 360px)" }
        : language
        ? { xs: "1fr", sm: "minmax(220px, 300px) minmax(150px, 180px)" }
        : { xs: "1fr", md: "minmax(280px, 380px) 1fr" };
    return (
        <Box
            data-testid={`${id}-settings`}
            sx={{
                ...(variant === "strip" && {
                    px: 2,
                    py: compact ? 1.25 : 2,
                    border: "1px solid",
                    borderColor: "divider",
                    borderRadius: 2,
                    bgcolor: "#f8fafc",
                }),
                ...sx,
            }}
        >
            {title && (
                <Typography
                    sx={{ fontSize: "0.72rem", fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase", color: "text.secondary", mb: compact ? 1 : 1.5 }}
                >
                    <FormattedMessage id="survey.settings_strip" defaultMessage="Assessment settings" />
                </Typography>
            )}
            <Box sx={{ display: "grid", gridTemplateColumns: columns, columnGap: 2, rowGap: compact ? 1 : 1.5, alignItems: "start" }}>
                <Box sx={{ minWidth: 0 }}>{project}</Box>
                {language && <Box sx={{ minWidth: 0 }}>{language}</Box>}
                {delivery && <Box sx={{ minWidth: 0 }}>{delivery}</Box>}
            </Box>
        </Box>
    );
}
